import { type JSX, type ReactNode, useId } from 'react';

/**
 * DER SEITENTYP EINSTELLUNGEN (ÄA-41, Entwurf v2) — Verwaltung,
 * Belege und Vorlagen, Umsysteme, Datenschutz, Betriebsprüfung, Mein Konto.
 *
 * Die Reiter stehen wie im Entwurf über dem Inhalt: Bei den Gruppen der
 * Verwaltung sind es die Sichten im Seitenkopf (Arbeitsfläche,
 * `REITERGRUPPEN`), in einer Maske mit eigenen Themen die Reiterleiste aus
 * `Akte.tsx`. Darunter steht JE THEMA EINE KARTE mit Überschrift und
 * Feldraster — nicht ein langes Formular, in dem man die Stelle sucht.
 */
export function Einstellungsseite({ children }: { readonly children: ReactNode }): JSX.Element {
  return <div className="einstellungen">{children}</div>;
}

/** Eine Karte je Thema: Überschrift (16 px / 500), Zusatz rechts, Inhalt. */
export function Thema({
  titel,
  zusatz,
  breit = false,
  children,
}: {
  readonly titel: string;
  /** Eine leise Angabe rechts in der Überschrift — Stand, Anzahl, Fassung. */
  readonly zusatz?: ReactNode;
  /** Über die ganze Breite, wo ein Thema eine breite Tabelle trägt. */
  readonly breit?: boolean;
  readonly children: ReactNode;
}): JSX.Element {
  const kennung = useId();
  return (
    <section className={breit ? 'karte thema thema--breit' : 'karte thema'} aria-labelledby={kennung}>
      <div className="karte__titel">
        <h2 id={kennung}>{titel}</h2>
        {zusatz !== undefined && <small>{zusatz}</small>}
      </div>
      {children}
    </section>
  );
}
